import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useCreateCushionChargePolicyMutation } from 'queries/company'
import { useCompanyDetailContextValue } from 'pages/Company/CompanyDetail/context/CompanyDetailProvider'

type CreateCushionChargePolicyFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useCreateCushionChargePolicyMutation>['mutate']
    reset: ReturnType<typeof useCreateCushionChargePolicyMutation>['reset']
  }
}

const [Context, useCreateCushionChargePolicyFlowContextValue] =
  createContext<CreateCushionChargePolicyFlowContextState>({
    name: 'CreateCushionChargePolicyFlowContext',
  })

export const CreateCushionChargePolicyFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const {
    state: { id: companyId },
  } = useCompanyDetailContextValue()
  const { mutate, reset, isPending, isError, error } =
    useCreateCushionChargePolicyMutation(companyId)

  const value: CreateCushionChargePolicyFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: isError ? parseErrorMessage(error) : undefined,
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useCreateCushionChargePolicyFlowContextValue }
